/* 
Displays a button to login via metamask and the current connected wallet address 
*/
import { Group, Button, Image } from "@mantine/core";
import EthAddress from "../../EthAddress/EthAddress";

export default function MetaMask(props) {
  return props.connectedWallet ? (
    <Group position="right" spacing={24}>
      <EthAddress
        address={props.connectedWallet}
        preamble={"Connected as "}
        cachedENS={props.cachedENS}
      />
    </Group>
  ) : (
    <Group position="right" spacing={24}>
      <Button
        radius="xs"
        uppercase
        onClick={props.connectWallet}
        variant="gradient"
        gradient={{ from: "#61892f", to: "#86c232", deg: 45 }}
      >
        <Group position="apart">
          Connect
          <Image
            radius="md"
            src="/metamask.png"
            alt="LOGO"
            width={24}
            height={24}
            fit="contain"
          />
        </Group>
      </Button>
    </Group>
  );
}
